import React from "react";
import "./styles/HotelApp.css";
import Board from "./Components/Board";
import TopBar from "./Components/TopBar";
import Helppanel from "./Components/Helppanel";
import { GameProvider } from "./GameContext";
import FullscreenToggle from "./FullscreenToggle";
import { GameStyleType } from "./Components/types/types";
const AppContent: React.FC<GameStyleType>= ({ GameStyle,Person}) => {
  return (
    <div id="hotel-content">
      <div className="hotel-conteiner">
        <div className="hotel-Logo-name">
          <a className="hotel-logo" title ="На главную" href="https://kotobot.app/index.html">
            <img className="hotel-logo" src="/img/kotobot.svg" alt="Kotobot logo" />
          </a>
           <div className="hotel-mainsubtitle">{`${GameStyle==="adress"?"Адресная книга":"Орбитальный портье"}`}</div>
          <FullscreenToggle/>
        </div>
        <TopBar />
        <Board GameStyle={GameStyle} Person={Person}/>
        <Helppanel GameStyle={GameStyle}/>
      </div>
    </div>
  );
};

const App: React.FC<GameStyleType>=  (props)  => {
  return (
    <GameProvider>
      <AppContent GameStyle={props.GameStyle} Person = {props.Person} />
    </GameProvider>
  );
};

export default App;